<template>
  <div style="width:100%">

    <div v-bind:class="['ui','right',{'action': searchByLocation},'left', 'icon', 'input', {'withlocation': searchByLocation},  'mblackoutline']" style="width: 100%;">
      <i class="search icon" style="margin-left:6px"></i>
      <input
      name="dealer-search"
      ref="autocomplete"
      type="text"
      :class="classname"
      :id="id"
      :placeholder="placeholder"
      v-model="autocompleteText"
      @focus="onFocus()"
      @blur="onBlur()"
      @change="onChange"
      @keypress="onKeyPress"
      @keyup="onKeyUp"
      />
      <div v-if="searchByLocation" v-bind:class="['ui', 'basic', 'floating', 'button' , 'target', {'disabled': searchByLocationError}]" @click="getCurrentLocation">
        <i v-bind:class="['icon','large',{'disabled': searchByLocationError },{'red': searchByLocationError}]" style="margin: 0px; margin-top: -2px;">
          <font-awesome-icon v-if="!searchingLocation" icon="crosshairs" class="loading"  />
          <div v-if="searchingLocation" class="ui active inline small loader" style="margin-top:-3px;"></div>
        </i>

      </div>
    </div>

    </div>
</template>

<script>

    import {gmapApi} from 'vue2-google-maps'

    const ADDRESS_COMPONENTS = {
        subpremise : 'short_name',
        street_number: 'short_name',
        route: 'long_name',
        locality: 'long_name',
        administrative_area_level_1: 'short_name',
        administrative_area_level_2: 'long_name',
        country: 'short_name',
        postal_code: 'short_name'
    };
    const CITIES_TYPE = ['locality', 'administrative_area_level_3'];
    const REGIONS_TYPE = ['locality', 'sublocality', 'postal_code', 'country',
        'administrative_area_level_1', 'administrative_area_level_2'];
    export default {
        name: 'GoogleAutocomplete',
        props: {
          id: {
            type: String,
            required: true
          },
          classname: String,
          placeholder: {
            type: String,
            default: 'Start typing'
          },
          types: {
            type: String,
            default: 'address'
          },
          country: {
            type: [String, Array],
            default: null
          },
          prevalue: {
            type: String,
            default: null
          },
          enableGeolocation: {
            type: Boolean,
            default: false
          },
          geolocationOptions: {
            type: Object,
            default: null
          },
          googleapikey: {
            type: String,
            default: null
          }
        },
        data() {
            return {
                /**
                 * The Autocomplete object.
                 *
                 * @type {Autocomplete}
                 * @link https://developers.google.com/maps/documentation/javascript/reference#Autocomplete
                 */
                autocomplete: null,
                /**
                 * Autocomplete input text
                 * @type {String}
                 */
                autocompleteText: '',
                geolocation: {
                    /**
                     * Google Geocoder Objet
                     * @type {Geocoder}
                     * @link https://developers.google.com/maps/documentation/javascript/reference#Geocoder
                     */
                    geocoder: null,
                    /**
                     * Filled after geolocate result
                     * @type {Coordinates}
                     * @link https://developer.mozilla.org/en-US/docs/Web/API/Coordinates
                     */
                    loc: null,
                    /**
                     * Filled after geolocate result
                     * @type {Position}
                     * @link https://developer.mozilla.org/en-US/docs/Web/API/Position
                     */
                    position: null
                },
                searchByLocation: false,
                searchByLocationError: false,
                searchingLocation: false
            }
        },
        watch: {
            autocompleteText: function (newVal, oldVal) {
              this.$emit('inputChange', { newVal, oldVal }, this.id);
            },
            country: function(newVal, oldVal) {
              this.autocomplete.setComponentRestrictions({
                country: this.country === null ? [] : this.country
              });
            },
            google(newValue, oldValue){
              this.init();
            }
        },
        created() {

          this.update(this.prevalue);

          if (navigator.geolocation) {
            this.searchByLocation = true;
          }

        },
        computed: {
          google: gmapApi
        },
        mounted: function() {

        },
        methods: {
            /**
             * When a place changed
             */
             init(){
               const options = {};
               if (this.types) {
                 options.types = [this.types];
               }
               if (this.country) {
                 options.componentRestrictions = {
                   country: this.country
                 };
               }
               this.autocomplete = new this.google.maps.places.Autocomplete(
                     document.getElementById(this.id),
                     options
                 );

               this.autocomplete.addListener('place_changed', this.onPlaceChanged);
               this.selectFirstPredictionOnEnter(document.getElementById(this.id));

             },

            getCurrentLocation(){

              if(this.searchByLocation){
                this.searchByLocationError = false;
                this.searchingLocation = true;
                let options = {
                  enableHighAccuracy: true,
                  timeout: 10000,
                  maximumAge: 0
                };

                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(this.setCurrentPosition,this.positionFailed, options);
                } else {
                  this.searchingLocation = false;
                  this.searchByLocationError = true
                }
              }

            },
            setCurrentPosition(position) {
              this.searchingLocation = false;
              this.updateCoordinates({'lat': position.coords.latitude, 'lng': position.coords.longitude});
            },
            positionFailed(e){
              console.log(e);
              this.searchingLocation = false;
              this.searchByLocationError = true;
            },
            onPlaceChanged() {


                let place = this.autocomplete.getPlace();

                if (!place.geometry) {
                  // User entered the name of a Place that was not suggested and
                  // pressed the Enter key, or the Place Details request failed.
                  this.$emit('no-results-found', place, this.id);
                  return;
                }
                if (place.address_components !== undefined) {

                    // return returnData object and PlaceResult object
                    this.$emit('placechanged', this.formatResult(place), place, this.id);
                    // update autocompleteText then emit change event
                    this.autocompleteText = document.getElementById(this.id).value
                    this.onChange()
                }
            },
            /**
             * When the input gets focus
             */
            onFocus() {
              this.biasAutocompleteLocation();
              this.$emit('focus');
            },
            /**
             * When the input loses focus
             */
            onBlur() {
              this.$emit('blur');
            },
            /**
             * When the input got changed
             */
            onChange() {
              this.$emit('change', this.autocompleteText);
            },
            /**
             * When a key gets pressed
             * @param  {Event} event A keypress event
             */
            onKeyPress(event) {

              if(event.key=="Enter"){

              }

              var suggestion_selected = $(".pac-item-selected").length > 0;
                    if (event.which == 13 && !suggestion_selected) {
                        var simulated_downarrow = $.Event("keydown", {
                            keyCode: 40,
                            which: 40
                        });



                        //orig_listener.apply(input, [simulated_downarrow]);
                    }

              this.$emit('keypress', event);
            },
            /**
             * When a keyup occurs
             * @param  {Event} event A keyup event
             */
            onKeyUp(event) {
              this.$emit('keyup', event);
            },
            /**
             * Clear the input
             */
            clear() {
              this.autocompleteText = ''
            },
            /**
             * Focus the input
             */
            focus() {
              this.$refs.autocomplete.focus()
            },
            /**
             * Blur the input
             */
            blur() {
              this.$refs.autocomplete.blur()
            },
            /**
             * Update the value of the input
             * @param  {String} value
             */
            update (value) {
              this.autocompleteText = value
            },
            /**
             * Update the coordinates of the input
             * @param  {Coordinates} value
             */
            updateCoordinates (value) {
                if (!value && !(value.lat || value.lng)) return;
                if (!this.geolocation.geocoder) this.geolocation.geocoder = new this.google.maps.Geocoder();
                this.geolocation.geocoder.geocode({'location': value}, (results, status) => {
                    if (status === 'OK') {
                        results = this.filterGeocodeResultTypes(results);
                        if (results[0]) {
                            this.$emit('placechanged', this.formatResult(results[0]), results[0], this.id);
                            this.update(results[0].formatted_address);
                        } else {
                            this.$emit('error', 'no result for provided coordinates');
                        }
                    } else {
                        this.$emit('error', 'error getting address from coords');
                    }
                })
            },
            /**
             * Update location based on navigator geolocation
             */
            geolocate () {
                this.updateGeolocation ((geolocation, position) => {
                    this.updateCoordinates(geolocation)
                })
            },
            /**
             * Update internal location from navigator geolocation
             * @param  {Function} (geolocation, position)
             */
            updateGeolocation (callback = null) {
                if (navigator.geolocation) {
                    let options = {};
                    if(this.geolocationOptions) Object.assign(options, this.geolocationOptions);
                    navigator.geolocation.getCurrentPosition(position => {
                        let geolocation = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        };
                        this.geolocation.loc = geolocation;
                        this.geolocation.position = position;
                        if (callback) callback(geolocation, position);
                    }, err => {
                        this.$emit('error', 'Cannot get Coordinates from navigator', err);
                    }, options);
                }
            },
            // Bias the autocomplete object to the user's geographical location,
            // as supplied by the browser's 'navigator.geolocation' object.
            biasAutocompleteLocation () {
                if (this.enableGeolocation) {
                    this.updateGeolocation((geolocation, position) => {
                        let circle = new this.google.maps.Circle({
                            center: geolocation,
                            radius: position.coords.accuracy
                        });
                        this.autocomplete.setBounds(circle.getBounds());
                    })
                }
            },
            /**
             * Format result from Geo google APIs
             * @param place
             * @returns {{formatted output}}
             */
            formatResult (place) {
                let returnData = {};
                for (let i = 0; i < place.address_components.length; i++) {
                    let addressType = place.address_components[i].types[0];
                    if (ADDRESS_COMPONENTS[addressType]) {
                        let val = place.address_components[i][ADDRESS_COMPONENTS[addressType]];
                        returnData[addressType] = val;
                    }
                }
                returnData['latitude'] = place.geometry.location.lat();
                returnData['longitude'] = place.geometry.location.lng();
                return returnData
            },
            /**
             * Extract configured types out of raw result as
             * Geocode API does not allow to do it
             * @param results
             * @returns {GeocoderResult}
             * @link https://developers.google.com/maps/documentation/javascript/reference#GeocoderResult
             */
            filterGeocodeResultTypes (results) {
                if (!results || !this.types) return results;
                let output = [];
                let types = [this.types];
                if (types.includes('(cities)')) types = types.concat(CITIES_TYPE);
                if (types.includes('(regions)')) types = types.concat(REGIONS_TYPE);
                for (let r of results) {
                    for (let t of r.types) {
                        if (types.includes(t)) {
                            output.push(r);
                            break;
                        }
                    }
                }
                return output;
            },
            selectFirstPredictionOnEnter(input) {
              var _addEventListener = (input.addEventListener) ? input.addEventListener : input.attachEvent;

              function addEventListenerWrapper(type, listener) {

                  if(type == 'keydown') {
                      var orig_listener = listener;

                      listener = function(event) {
                          var suggestion_selected = $(".pac-item-selected").length > 0;

                          if (event.which == 13 && !suggestion_selected) {
                              var simulated_downarrow = $.Event("keydown", {
                                  keyCode: 40,
                                  which: 40
                              });

                              orig_listener.apply(input, [simulated_downarrow]);
                          }

                          orig_listener.apply(input, [event]);
                      };
                  }

                  _addEventListener.apply(input, [type, listener]);
              }

              if (input.addEventListener)
                  input.addEventListener = addEventListenerWrapper;
              else if (input.attachEvent)
                  input.attachEvent = addEventListenerWrapper;
            }
        }
    }
</script>
<style>

.target{
  width:65px;
  text-align:center;
  border-top-left-radius: 0!important;
  border-bottom-left-radius: 0!important;
  border-top-right-radius: .28571429rem!important;
  border-bottom-right-radius: .28571429rem!important;
  background-color: white!important;

}
.ui.button:disabled, .ui.buttons .disabled.button, .ui.disabled.active.button, .ui.disabled.button, .ui.disabled.button:hover {
    border: 1px solid lightgrey;
}
.withlocation{
  padding-right: 65px;
}
</style>
